module.exports = __webpack_public_path__ + "static/media/icon-invoice.26aeeeea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-invoice.svg
// module id = 3244
// module chunks = 0